"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YYYY_MM_DD = void 0;
exports.getDatesInView = getDatesInView;
exports.getIncrementedFocusDate = getIncrementedFocusDate;
exports.reducerSelectDates = reducerSelectDates;
exports.reducerToggleDatePicker = reducerToggleDatePicker;
exports.shouldShowNextIndicator = shouldShowNextIndicator;
exports.shouldShowPrevIndicator = shouldShowPrevIndicator;
exports.updateDatesChosen = updateDatesChosen;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _isSameOrAfter = _interopRequireDefault(require("dayjs/plugin/isSameOrAfter"));
var _Calendar = require("../Calendar/Calendar.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
_dayjs.default.extend(_isSameOrAfter.default);
const YYYY_MM_DD = exports.YYYY_MM_DD = "YYYY-MM-DD";
function shouldShowPrevIndicator(focusDate) {
  let minDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _dayjs.default)();
  let prevMonth = (0, _dayjs.default)(focusDate).subtract(1, "months").startOf("month");
  let minMonth = (0, _dayjs.default)(minDate).startOf("month");
  return prevMonth.isBefore(minMonth) ? false : true;
}
function shouldShowNextIndicator(focusDate) {
  let maxDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _dayjs.default)().add(1, "year");
  let numberOfCalendars = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let nextMonth = (0, _dayjs.default)(focusDate).startOf("month");
  if (numberOfCalendars > 1) {
    // need to account for the "extra" months displayed beyond the first
    const addCount = numberOfCalendars - 1;
    nextMonth.add(addCount, "months");
  }
  let maxMonth = (0, _dayjs.default)(maxDate).startOf("month");
  return nextMonth.isSameOrAfter(maxMonth) ? false : true;
}
function getDatesInView(state) {
  let result = [];
  const numberOfCalendars = state.numberOfCalendars || 2;
  for (let i = 0; i < numberOfCalendars; i++) {
    if (i === 0) {
      result.push((0, _Calendar.createMonth)((0, _dayjs.default)(state.focusDate), state));
    } else {
      result.push((0, _Calendar.createMonth)((0, _dayjs.default)(state.focusDate).add(i, "months"), state));
    }
  }
  return result;
}
function getIncrementedFocusDate(date, direction) {
  let newFocusDate;
  if (direction === "forward") {
    newFocusDate = (0, _dayjs.default)(date).add(1, "months");
  } else {
    newFocusDate = (0, _dayjs.default)(date).subtract(1, "months");
  }
  return newFocusDate;
}
function updateDatesChosen(dateClicked, state) {
  const {
    datesChosen,
    isRange
  } = state;
  // no date chosen yet
  if (datesChosen.length === 0) {
    return [dateClicked];
  }

  // non-range
  if (!isRange) {
    return [dateClicked];
  }

  // is range, existing first date chosen
  if (isRange && datesChosen.length === 1) {
    if (!Boolean(datesChosen[0]) || Boolean(datesChosen[0]) && dateClicked.unix() < datesChosen[0].unix()) {
      // dateChosen[0] === null/undefined... OR... dateClicked is prior to existing single date chosen
      return [dateClicked];
    }

    // dateClicked is same as first chosen date
    if (datesChosen[0] && dateClicked.format(YYYY_MM_DD) === datesChosen[0].format(YYYY_MM_DD)) {
      // return current dates chosen,
      // this will keep the calendar open until manually closed or new date selected
      return datesChosen;
    }

    // dateClicked is after existing first chosen date
    return [...datesChosen, dateClicked];
  }

  // 2 existing dates chosen
  if (datesChosen.length === 2) {
    return [dateClicked];
  }

  // no conditions above match
  return [];
}
function reducerSelectDates(state, action) {
  let closeOnSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const nextDatesChosen = updateDatesChosen(action.payload, state);
  let nextShowCalendar;
  if (closeOnSelection) {
    nextShowCalendar = state.isRange ? !(nextDatesChosen.length === 2) : !(nextDatesChosen.length === 1);
  } else {
    nextShowCalendar = true;
  }
  const nextDateHovered = nextShowCalendar === false ? null : state.dateHovered;
  const nextVisibleDates = getDatesInView(_objectSpread(_objectSpread({}, state), {}, {
    dateHovered: nextDateHovered,
    datesChosen: nextDatesChosen
  }));
  return _objectSpread(_objectSpread({}, state), {}, {
    datesChosen: nextDatesChosen,
    showCalendar: nextShowCalendar,
    visibleDates: nextVisibleDates
  });
}
function reducerToggleDatePicker(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showCalendar: !state.showCalendar
  });
}